import { all } from 'redux-saga/effects';
import createUserAddressSaga from './create_user_address.saga';
import changeUserAddressSaga from './change_user_address.saga';
import removeUserAddressSaga from './remove_user_address.saga';
import getUserAddressSaga from './get_user_address.saga';

export default function* userAddressRootSaga() {
    yield all([
        getUserAddressSaga(),
        createUserAddressSaga(),
        changeUserAddressSaga(),
        removeUserAddressSaga(),
    ]);
}



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/sagas/user_addresses_sagas/addresses_root.saga.js